// @ts-nocheck



import React from 'react';
import { convertVehicleToString } from '../../lib/helpers';
import { vehicleApi } from './../../lib/api';


import AutocompleteSelect from './AutocompleteSelect';










const defaultOptionName = (vehicle) => convertVehicleToString(vehicle);

export default class extends React.Component {
  shouldComponentUpdate(nextProps) {
    if (nextProps.value !== this.props.value) {
      return true;
    }
    return false;
  }

  render() {
    const {
      optionTitle = defaultOptionName,
      filter = {},
      disabledValues = [],
      ...selectProps
    } = this.props;
    return (
      <AutocompleteSelect
        placeholder="Выберите ТС"
        fetch={async (params) =>
        await vehicleApi.fetchVehicles({ ...params, ...filter })
        }
        refetchParams={{ filter }}
        fetchSingle={vehicleApi.fetchVehicle}
        notFoundText="ТС не найдены"
        renderOption={(vehicle, Option) =>
        <Option
          key={vehicle.id}
          value={vehicle.id}
          vehicle={vehicle}
          disabled={disabledValues.includes(vehicle.id)}>

            {optionTitle(vehicle)}
          </Option>
        }
        {...selectProps} />);


  }
}
